import { useTranslation } from "react-i18next";
import { CalendarDays, Lock } from "lucide-react";

// شريط الإجازة السنوية — أفقي قابل للضغط، يعرض تقدّم استحقاق الـ365 يوماً أو نسبة المستخدم.
export const AnnualLeaveBar = ({ balance, active, onClick }) => {
  const { t } = useTranslation();
  const locked = Boolean(balance.annual_locked);
  const allowed = balance.quotas?.annual?.allowed ?? 0;
  const remaining = balance.quotas?.annual?.remaining ?? 0;
  const used = Math.max(allowed - remaining, 0);
  const pct = locked
    ? Math.min(100, Math.round(((365 - (balance.annual_days_left || 0)) / 365) * 100))
    : allowed > 0 ? Math.round((used / allowed) * 100) : 0;
  const state = active ? "shadow-neu-in" : "shadow-neu-sm hover:-translate-y-0.5";

  return (
    <button type="button" onClick={onClick} data-testid="leave-tile-annual"
            className={`grid gap-2 rounded-2xl bg-background p-3 text-start transition-all sm:p-4 ${state}`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full shadow-neu-sm ${locked ? "bg-muted text-muted-foreground" : "bg-emerald-500 text-white"}`}>
            {locked ? <Lock className="h-4 w-4" /> : <CalendarDays className="h-4 w-4" strokeWidth={2.5} />}
          </span>
          <p className="text-sm font-black">{t("leaves.types.annual")}</p>
        </div>
        <p className={`text-xs font-bold ${locked ? "text-destructive" : "text-muted-foreground"}`}>
          {locked
            ? t("leaves.annualLockedShort", { days: balance.annual_days_left })
            : `${used} / ${allowed}`}
        </p>
      </div>
      <div className="rounded-full bg-background p-[3px] shadow-neu-in">
        <div className={`h-2.5 rounded-full transition-all ${locked ? "bg-rose-400" : "bg-emerald-500"}`}
             style={{ width: `${Math.max(pct, 4)}%` }} />
      </div>
    </button>
  );
};
